import { Switch } from '@thanx/uikit/switch'
import ExclamationTriangleO from 'components/Icons/ExclamationTriangleO'
import { buildTranslate } from 'locales'
import { Fields as Product } from 'models/Product'
import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import { useStyletron } from 'styletron-react'
import { merchantTheme } from 'theme'
import { currencyFormatter } from 'utilities/formatters'
import placeholder from './placeholder.svg'
import ProductModal from './ProductModal'

const t = buildTranslate('redeem_manager.product_select')

type Props = {
  product: Product
  displayDeleteIcon?: boolean
  onDelete?: () => void
  warningTooltip?: string
}

const ProductItem = ({
  product,
  displayDeleteIcon,
  onDelete,
  warningTooltip,
}: Props) => {
  const [isModalOpen, setModalOpen] = useState(false)
  const { name, price, image } = product
  const [css] = useStyletron()

  return (
    <>
      <div className="d-flex align-items-center border-1 grey-30-border border-radius-5 grey-05-bkg p-xs mb-xs">
        <Switch condition={!!warningTooltip}>
          <span role="img" aria-label={warningTooltip} className="d-flex mr-xs">
            <span aria-hidden="true" className="d-flex">
              <ExclamationTriangleO
                pathColor={merchantTheme.colors.eggYolk50}
                testId="warning-icon"
              />
            </span>
          </span>
        </Switch>
        <img
          alt={name}
          className={`${css({
            width: '32px',
            height: '32px',
          })} mr-xs`}
          src={image.default || placeholder}
        />
        <p className="flex-1 mb-0 body-text-4 grey-70">{name}</p>
        <Switch condition={price > 0}>
          <p className="mr-xs mb-0 body-text-4 grey-70">
            {currencyFormatter(price)}
          </p>
        </Switch>
        <Button
          bsStyle="link"
          className={`${css({
            minWidth: '75px',
          })} m-0 ml-auto p-0`}
          onClick={() => setModalOpen(true)}
        >
          {t('show_more')}
        </Button>
        <Switch condition={!!displayDeleteIcon}>
          <span
            className="font-size-24 grey-70 light cursor-pointer"
            title="delete"
            onClick={onDelete}
          >
            &times;
          </span>
        </Switch>
      </div>

      <ProductModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        product={product}
      />
    </>
  )
}

export default ProductItem
